import React, {Component} from 'react';
import PropTypes from "prop-types";
import UserAddContainer from "./UserAddContainer";
import UserEditContainer from "./UserEditContainer";
import UserOverviewContainer from "./UserOverviewContainer";
import StaticFunctions from "../../utils/StaticFunctions";

class UsersContainer extends Component {

    static propTypes = {
        baseData: PropTypes.object.isRequired,
    };

    constructor(props) {

        super(props);

        this.state = {
            activeView: null,
            userEdit: null,
        };

        this.translate = this.props.baseData.translate;

        this.rights = [
            {
                label: this.translate('login'),
                value: 'login',
                init: true,
            },
            {
                label: this.translate('administration'),
                value: 'companyadmin',
                init: false,
            },
            {
                label: this.translate('translations'),
                value: 'translations',
                init: false,
            },
            /*{
                label: this.translate('right_login_punchshop'),
                value: 'ps_login',
                init: false,
            },
            {
                label: this.translate('right_punchshop_puncher'),
                value: 'ps_puncher',
                init: false,
            },
            {
                label: this.translate('right_login_designshop'),
                value: 'designshop_login',
                init: false,
            },
            {
                label: this.translate('right_designshop_vendor'),
                value: 'designshop_vendor',
                init: false,
            },*/
        ];

        this.changeView = this.changeView.bind(this);

    }

    changeView(activeView = null, userEdit = null) {

        this.setState({
            activeView,
            userEdit
        });

    }

    renderView() {

        const view = this.state.activeView;
        const rights = this.rights; //  StaticFunctions.getSortedData(this.rights, 'label', 'string');

        if (view === 'add') {
            return <UserAddContainer
                baseData={this.props.baseData}
                rights={rights}
                changeView={this.changeView}
            />;
        } else if (view === 'edit') {
            return <UserEditContainer
                baseData={this.props.baseData}
                user={this.state.userEdit}
                rights={rights}
                changeView={this.changeView}
            />;
        } else {
            return <UserOverviewContainer
                baseData={this.props.baseData}
                currentCompany={this.props.baseData.companies.currentCompany}
                changeView={this.changeView}
            />;
        }

    }

    render() {

        const renderedView = this.renderView();

        return (
            <div>
                {renderedView}
            </div>
        );

    }

}

export default UsersContainer;